import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { commitChanges } from "./patientDetailsSlice";
import { useSelector, useDispatch } from "react-redux";
import PersonalDetails from "./forms/PersonalDetails";
import AdditionalInfo from "./forms/AdditionalInfo";
import Specifications from "./forms/Specifications";
import Relatives from "./forms/Relatives";
import Apotropus from "./forms/Apotropus";
import Payments from "./forms/Payments";
import ContactInformation from "./forms/ContactInformation";
import Corporation from "./forms/Corporation";
import MedicalInfo from "./forms/MedicalInfo";
import Availability from "./forms/Availability";
import PatientReferences from "../patientReferences";
import FormWrapper from "./forms/FormWrapper";
import ContentSider from "../../components/templates/ContentSider";
import PageAnchor from "../../components/templates/PageAnchor";
import PrintFormsTable from "../../components/companyforms/PrintFormsTable";
import { isAllowedFeature } from "../organization/organizationSlice";
import {
  AuditOutlined,
  CarryOutOutlined,
  ExceptionOutlined,
  DollarOutlined,
} from "@ant-design/icons";
const { Content } = Layout;

const PatientDetails = (props) => {
  const { mode } = props;
  const [selectedKeys, setSelectedKeys] = useState(null);

  let history = useHistory();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const saveLoading = useSelector(
    (state) => state.pendingActions["patientDetails/update"]
  );

  useEffect(() => {
    setSelectedKeys("personalDetails");
  }, []);

  const dispatch = useDispatch();

  const onMenuSelect = ({ key }) => {
    setSelectedKeys([key]);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    history.goBack();
  };

  const getMenuItems = () => [
    {
      name: "personalDetails",
      comp: <PersonalDetails />,
      category: "patients",
      icon: <AuditOutlined />,
    },
    {
      name: "contactInformation",
      comp: <ContactInformation />,
      category: "patients",
      icon: <CarryOutOutlined />,
    },
    {
      name: "additional_information",
      comp: <AdditionalInfo activePatient={activePatient} />,
      category: "patients",
      icon: <ExceptionOutlined />,
    },
    {
      name: "specifications",
      comp: <Specifications activePatient={activePatient} />,
      category: "patients",
      icon: <ExceptionOutlined />,
    },
    {
      name: "patient_references",
      comp: <PatientReferences />,
      category: "patients",
      icon: <ExceptionOutlined />,
    },
    {
      name: "relatives",
      comp: <Relatives activePatient={activePatient} />,
      category: "patients",
      icon: <DollarOutlined />,
    },
    {
      name: "availability",
      comp: <Availability activePatient={activePatient} />,
      category: "patients",
      icon: <DollarOutlined />,
    },
    {
      name: "apotropus",
      comp: <Apotropus />,
      category: "patients",
      icon: <DollarOutlined />,
    },
    {
      name: "corporation",
      comp: <Corporation activePatient={activePatient} />,
      category: "patients",
      icon: <CarryOutOutlined />,
    },
    {
      name: "payments",
      comp: <Payments activePatient={activePatient} />,
      category: "patients",
      icon: <DollarOutlined />,
    },

    {
      name: "medical_information",
      comp: <MedicalInfo />,
      category: "patients",
      icon: <ExceptionOutlined />,
    },
    ...(isAllowedFeature("forms")
      ? [
          {
            name: "forms",
            comp: (
              <PrintFormsTable
                entity="patient"
                entityId={activePatient.id}
                entityCollection="patients"
              />
            ),
            category: "patients",
            icon: <CarryOutOutlined />,
          },
        ]
      : []),
  ];

  return (
    <Layout
      style={{
        background: "transparent",
        height: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div style={{ height: "100px", width: "20px" }} />
      <ContentSider width={250}>
        <PageAnchor
          onMenuSelect={onMenuSelect}
          items={getMenuItems()}
          selectedKeys={selectedKeys}
        />
      </ContentSider>
      <Content>
        <FormWrapper
          mode={mode}
          onSubmit={() => dispatch(commitChanges())}
          onFinishFailed={onFinishFailed}
          hideDelete={true}
          onDecline={onDecline}
          saveLoading={saveLoading}
          padding={true}
        >
          {getMenuItems().map((i) => (
            <div key={i.name} id={i.name}>
              {i.comp}
            </div>
          ))}
        </FormWrapper>
      </Content>
    </Layout>
  );
};

PatientDetails.propTypes = {
  mode: PropTypes.string,
};

export default PatientDetails;
